export const uphocLogo = require('./logos/logo-uphoc.jpg');
export const pulsarLogo = require('./logos/logo-pulsar.png');
export const applLogo = require('./logos/appl_logo.png');
export const cerpanLogo = require('./logos/cerpan_logo.png');
export const blackpoint = require('./blackpoint.png');
export const blackpointEconomic = require('./blackpoint-economic.png');
export const blackpointHealthy = require('./blackpoint-healthy.png');
export const blackpointSpecial = require('./blackpoint-special.png');
export const blackpointInactive = require('./blackpoint-inactive.png');
export const dutyDay = require('./duty-day.png');
export const dutyNight = require('./duty-night.png');
export const dutyDayNight = require('./duty-day&night.png');
export const dutyOff = require('./duty-off.png');
export const iconE = require('./icon-E.png');
export const bankHoliday = require('./bankHoliday.png');
export const bankHolidayDutyOffRequest = require('./bankHolidayDutyOffRequest.png');
export const iconModification = require('./iconModification.png');
export const iconToday = require('./iconToday.png');

export const crossBlue = require('./cross-blue.png');
export const crossYellow = require('./cross-yellow.png');
export const flag = require('./flag.png');
export const gray = require('./gray.png');
export const grayDot = require('./gray-dot.png');
export const green = require('./green.png');
export const greenDot = require('./green-dot.png');
export const greenPushpin = require('./grn-pushpin.png');
export const blue = require('./blue.png');
export const blueDot = require('./blue-dot.png');
export const lightblue = require('./lightblue.png');
export const lightblueDot = require('./lightblue-dot.png');
export const orange = require('./orange.png');
export const red = require('./red.png');
export const redDot = require('./red-dot.png');
export const redPushpin = require('./red-pushpin.png');
export const yellow = require('./yellow-v3.png');
export const yellowDot = require('./yellow-dot-v2.png');
export const mm20Gray = require('./mm_20_grayV2.png');
export const mm20Yellow = require('./mm_20_yellow-v2.png');
export const mm20Red = require('./mm_20_red.png');
export const icon3 = require('./icon3.png');
export const icon11 = require('./icon11.png');
export const spotlightGrey = require('./gray32-v5.png');
export const spotlightGreyDot = require('./gray32-dot-v6.png');
export const help = require('./info.svg');

export const permanent_protection = require('./protection_permanente.png')
export const temporary_protection = require('./protection_temporaire.png')
export const authorized_location = require('./implantation_possible.png')
